import { ShoppingBag, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CartItemsList } from "./CartItemsList";

const fmt = (n) => new Intl.NumberFormat("fr-FR").format(n);

export const CartPanel = ({ cart, onCheckout }) => (
  <aside className="bg-[#1A1A1A] border border-white/10 rounded-3xl p-5 flex flex-col gap-4" data-testid="cart-panel">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <ShoppingBag className="w-5 h-5 text-[#D4AF37]" />
        <h3 className="font-black uppercase tracking-widest text-sm text-white">Mon panier</h3>
      </div>
      <span className="text-xs font-bold text-white/50" data-testid="cart-count">{cart.count} article{cart.count > 1 ? "s" : ""}</span>
    </div>
    {cart.items.length === 0 ? (
      <p className="text-sm text-white/50 py-6 text-center" data-testid="cart-empty">
        Votre panier est vide. Ajoutez des produits pour commander.
      </p>
    ) : (
      <>
        <div className="max-h-[50vh] overflow-y-auto pr-1">
          <CartItemsList items={cart.items} onQty={cart.setQty} />
        </div>
        <div className="flex justify-between items-center pt-3 border-t border-white/10">
          <span className="text-xs font-black uppercase tracking-widest text-white/60">Sous-total</span>
          <span className="text-lg font-black text-[#D4AF37]" data-testid="cart-subtotal">{fmt(cart.total)} FCFA</span>
        </div>
        <Button onClick={onCheckout} className="w-full bg-[#D4AF37] hover:bg-[#B8962E] text-[#0F172A] rounded-full font-black uppercase tracking-widest text-xs py-5 transition-colors" data-testid="cart-checkout-btn">
          Valider mon panier <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
        <button type="button" onClick={cart.clear} className="text-xs text-white/40 hover:text-red-400 transition-colors" data-testid="cart-clear-btn">
          Vider le panier
        </button>
      </>
    )}
  </aside>
);
